import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => (
  <div className="text-center py-5">
    <h1>Page not found</h1>
    <p className="text-muted">The page you are looking for does not exist.</p>
    <Link to="/">Return home</Link>
  </div>
)

export default NotFound
